import type { ColumnDef } from "@tanstack/react-table";
import type { ProductSource } from "@/types";
import { Badge } from "@trillion/ui/components/ui/badge";
import { createActionsColumn } from "@trillion/ui";

interface NetworkColumnsOptions {
  onEdit: (network: ProductSource) => void;
  onDelete: (network: ProductSource) => void;
}

export function getNetworkColumns({
  onEdit,
  onDelete,
}: NetworkColumnsOptions): ColumnDef<ProductSource>[] {
  return [
    {
      accessorKey: "code",
      header: "Code",
      cell: ({ row }) => <span className="font-mono text-sm">{row.getValue("code")}</span>,
    },
    {
      accessorKey: "name",
      header: "Name",
      cell: ({ row }) => (
        <div className="max-w-[200px] truncate font-medium">{row.getValue("name")}</div>
      ),
    },
    {
      accessorKey: "tracking_config",
      header: "Tracking Config",
      cell: ({ row }) => {
        const config = row.getValue("tracking_config") as string | null;
        return config ? (
          <span className="block max-w-[240px] truncate font-mono text-xs text-muted-foreground">
            {config}
          </span>
        ) : (
          <span className="text-muted-foreground">-</span>
        );
      },
    },
    {
      accessorKey: "active",
      header: "Status",
      cell: ({ row }) => {
        const active = row.getValue("active") as boolean;
        return (
          <Badge variant={active ? "default" : "destructive"}>
            {active ? "Active" : "Inactive"}
          </Badge>
        );
      },
    },
    {
      accessorKey: "created_date",
      header: "Created",
      cell: ({ row }) => {
        const date = row.getValue("created_date") as string;
        return <span className="text-muted-foreground">{new Date(date).toLocaleDateString()}</span>;
      },
    },
    createActionsColumn<ProductSource>({ onEdit, onDelete }),
  ];
}
